module.exports = __webpack_public_path__ + "static/media/Deutschland.88799957.svg";